import React from "react";
import { FuelGauge } from "./";
import { styled } from "@mui/material/styles";
import { Grid, Typography } from "@mui/material";

const TextMeta = styled(Typography)`
  && {
    font-weight: bold;
    align-self: center;
  }
`

const ChildItem = styled('div')({
  display: "flex",
  alignItems: "center",
  height: "50%",
  justifyContent: "center"
})

function FuelInfo({ fuel_level }) {
  return (
    <Grid item>
      <TextMeta>Fuel Level:</TextMeta>
      <ChildItem>
        <FuelGauge width={"3rem"} value={fuel_level}/>
        <Typography style={{ fontWeight: "bold", marginLeft: "10px" }}>{fuel_level}%</Typography>
      </ChildItem>
    </Grid>
  )
}

export { FuelInfo };
